import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, Select, DatePicker, Radio, Checkbox, Collapse, notification, Divider, InputNumber } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Tabs } from 'antd';
import { EnvironmentOutlined, AuditOutlined, HomeOutlined, FileProtectOutlined, DollarCircleOutlined } from '@ant-design/icons';


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { claveDescuentoCreateAction, claveDescuentoReadAction } from '../../../redux/configuracion/claveDescuento/actionCreator';

const dateFormat = 'YYYY-MM-DD';

const ClaveDescuentoMainForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const registro = useSelector(state => state.ClaveDescuentoCrudReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams(); // Esta funcion nos ayuda a leer los parametros recibidos (en caso de exista)
  const [form] = Form.useForm();


  useEffect(() => {
    if (id) // Cuando se este editando un registro, tendremos un ID en los parametros, por lo tanto podremos buscar en el api este regsitro
      dispatch(claveDescuentoReadAction(id));
    else {
      dispatch(claveDescuentoReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) { // Cuando la llamada al API fue exitosa, ya tendremos el objecto en la variable "registro" y podemos pasar estos valores al formulario     
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const handleSubmit = async (values) => { 
    
    let action = 'create';
    if (id) {
      action = 'update';
    }
    const responseApi = await dispatch(claveDescuentoCreateAction({
      ...values,
      action: action
    }));    
    if (responseApi) {
      let mensaje = 'Clave descuento creada exitosamente';
      if (action === "update") mensaje = 'Clave descuento actualizada exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      history.replace('/admin/catalogos/clave-descuento/listado');
    } else {
      notification.error({
        message: 'Error al gestionar la clave descuento',
      });
    }
  };

  const handleValidate = (value) => {
    console.log("-----------handleValidate---------")
    const isValid = isValidPhoneNumber(value);
    
    console.log({ isValid })
    return isValid
  }

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/catalogos/clave-descuento/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="FICHA DE LA CLAVE DESCUENTO"
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Form
              className="add-record-form"
              style={{ width: '100%' }}
              layout="horizontal"
              size="small"
              form={form}
              name="addnew"
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>
                  <BasicFormWrapper>                  
                    <Form.Item name="contrasena" label="Constraseña" rules={[{ message: 'Campo obligatorio.', required: true }]}>
                      <Input placeholder="Ej. descuento20" />
                    </Form.Item>                   
                    <Form.Item name="porcentaje" label="Porcentaje" rules={ [ { message: 'Campo obligatorio.', required: true }, { pattern: "^[0-9]*$", message: 'Solo se aceptan números' }, { max: 3, message: 'Solo se aceptan 3 números' } ] }>
                      <Input placeholder="Ej. 20" />
                    </Form.Item>                   
                    <Form.Item name="id" initialValue="0" noStyle>
                      <Input hidden />
                    </Form.Item>                
                  </BasicFormWrapper>

                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default ClaveDescuentoMainForm;
